import { formatDDMMMYY } from '../index';
import { extractBefore, EXTRACT_BEFORE_KEYWORDS } from './extractBefore';

export const appendTermsAndConditionsLink = (messages = [], promoDetailsDefaultRef) => {
    if (!messages?.length) return [];

    return messages.map(messageItem => {
        if (!messageItem?.promoCode) return messageItem;

        const thresholdValue = extractBefore(messageItem?.promoCode, EXTRACT_BEFORE_KEYWORDS.SENIORSHIP);
        const promoData = JSON.stringify({
            promoCode: messageItem?.promoCode,
            ...(messageItem?.promoStartDate && { promoStartDate: formatDDMMMYY(messageItem.promoStartDate) }),
            ...(messageItem?.promoEndDate && { promoEndDate: formatDDMMMYY(messageItem.promoEndDate) }),
            ...(thresholdValue && { thresholdValue }),
            ...(thresholdValue && promoDetailsDefaultRef && {
                promoDetailsDefaultRef
            })
        })

        const termsAndConditionsLink = `<a
            class="jos-show-terms-and-conditions"
            role="button"
            tabindex="0"
            aria-haspopup="dialog"
            aria-expanded="false"
            data-promo='${promoData}'
            >* See details and exclusions</a>`

        return {
            ...messageItem,
            message: `${messageItem.message} ${termsAndConditionsLink}`
        }
    })
}